export interface NickIRichTextOptions {
  placeholder?: string;
  language?: string;
}
// todo: Migrate to correct locale (FlunaForms)
